import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

type LookupType = 'GROWER' | 'VARIETY' | 'BLOCK' | 'VEHICLE_REG' | 'PUC'

export function useLookupValues(type: LookupType) {
  return useQuery({
    queryKey: ['lookup', type],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('lookup_values')
        .select('value')
        .eq('type', type)
        .order('value')
      if (error) throw error
      return data.map(r => r.value as string)
    },
    staleTime: 5 * 60_000, // lookups rarely change — cache for 5 mins
  })
}

// Fetch all lookup types at once for the intake form
export function useIntakeLookups() {
  const growers     = useLookupValues('GROWER')
  const varieties   = useLookupValues('VARIETY')
  const blocks      = useLookupValues('BLOCK')
  const vehicleRegs = useLookupValues('VEHICLE_REG')

  return { growers, varieties, blocks, vehicleRegs }
}
